/*-------------------------------MODULES-KEYS-----------------------------------*/
export const TRANSACTIONS_ROUTE_MODULE_KEY = "transactions";
export const PACKAGES_ROUTE_MODULE_KEY = "packages";
export const SOUSCRIPTIONS_ROUTE_MODULE_KEY = "souscriptions";
/*-------------------------------ERRORS------------------------------------*/
export const NOT_FOUND_ERROR_PAGE_ROUTE = "/page-introuvable";
export const SERVER_ERROR_PAGE_ROUTE = "/erreur-serveur";
export const NETWORK_ERROR_PAGE_ROUTE = "/erreur-reseau";
/*---------------------------------AUTH------------------------------------*/
export const LOGIN_PAGE_ROUTE = "/connexion";
export const ROOT_ROUTE = "";
/*-------------------------------PACKAGES------------------------------------*/
export const NOUVEAU_PACKAGE_PAGE_ROUTE = "/packages/nouveau";
export const MODIFICATION_PACKAGE_PAGE_ROUTE =
  "/packages/modification/:packageId";
export const CONSULTATION_PACKAGES_PAGE_ROUTE = "/packages/consultation";
export const GESTION_PACKAGES_PAGE_ROUTE = "/packages/gestion";
export const DETAIL_CONSULTATION_PACKAGES_PAGE_ROUTE =
  "/packages/detail/:packageId";
/*-------------------------------TRANSACTIONS------------------------------------*/
export const CONSULTATION_TRANSACTIONS_PAGE_ROUTE =
  "/transactions/consultation";

/*-------------------------------SOUSCRIPTION------------------------------------*/
export const CONSULTATION_SOUSCRIPTIONS_PAGE_ROUTE =
  "/souscriptions/consultation";
export const GESTION_SOUSCRIPTIONS_PAGE_ROUTE = "/souscriptions/gestion";
export const DETAIL_SOUSCRIPTION_PAGE_ROUTE = "/souscriptions/detail/:id";
export const PAIEMENT_SOUSCRIPTION_PAGE_ROUTE = "/souscriptions/paiement/:id";
export const NOUVELLE_SOUSCRIPTION_PAGE_ROUTE =
  "/souscriptions/:packageId/nouveau";
export const SUCCESS_PAYMENT_PAGE_ROUTE = "/souscriptions/success";

export const SUCCESS_PAYMENT_PAGE_ERROR = "/souscriptions/error";
